/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { ErrorMessage, Field, useFormikContext } from 'formik'
import Input from 'components/common/input/Input'
import CustomDatePicker from 'components/common/custom-datepicker/CustomDatepicker'
import SelectComponent from 'components/common/select/SelectComponent'
import moment from 'moment'
import MapViewWrapper from 'components/common/map-view/MapView'

const EVENT_LOCATION_MODE_OPTIONS = [
  { value: 'onsite', label: 'Onsite' },
  { value: 'online', label: 'Online' },
]

function LocationTimeStep() {
  const formik = useFormikContext()

  return (
    <div className='event-create-card event-location-card'>
      <p className='heading-lg mb-3'>Location &amp; Time</p>
      <div className='row event-location-grid'>
        <div className='col-md-6 event-location-grid__item'>
          <CustomDatePicker
            name='startDate'
            label='Date From'
            dateFormat='dd / MM / yyyy'
            placeholderText='DD / MM / YYYY'
            selected={
              formik.values.startDate
                ? new Date(moment(formik.values.startDate))
                : ''
            }
            onDateChange={(date) => formik.setFieldValue('startDate', date)}
          />
          <ErrorMessage className='error-text' component='p' name='startDate' />
        </div>
        <div className='col-md-6 event-location-grid__item'>
          <CustomDatePicker
            name='endDate'
            label='Date To'
            dateFormat='dd / MM / yyyy'
            placeholderText='DD / MM / YYYY'
            selected={
              formik.values.endDate
                ? new Date(moment(formik.values.endDate))
                : ''
            }
            onDateChange={(date) => formik.setFieldValue('endDate', date)}
          />
          <ErrorMessage className='error-text' component='p' name='endDate' />
        </div>
        {formik.values.type === 'onsite' ? (
          <>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '4px',
                marginBottom: '10px',
              }}
              className='col-12'
            >
              <Field
                name='separatedByDays'
                type='checkbox'
                style={{ marginRight: '6px', height: '26px' }}
                checked={formik.values.separatedByDays}
              />
              <p className='mb-0'>Events separated by days</p>
            </div>
            <div className='col-12 mt-2'>
              <div className='event-field'>
                <p className='event-field__label'>Location Type</p>
                <div className='event-field__control event-field__control--select'>
                  <SelectComponent
                    name='type'
                    options={EVENT_LOCATION_MODE_OPTIONS}
                    selectedValue={formik.values.type}
                    placeholder='Select online or offline'
                    handleChange={(obj) => {
                      const nextType = obj?.value
                      formik.setFieldValue('type', nextType)
                      if (nextType === 'online') {
                        formik.setFieldValue('location.address', '')
                        formik.setFieldValue('location.mapUrl', '')
                      } else {
                        formik.setFieldValue('webLink', '')
                      }
                    }}
                  />
                </div>
                <ErrorMessage className='error-text' component='p' name='type' />
              </div>
            </div>
            <div className='col-12 mt-2 mb-2'>
              <div className='event-field'>
                <p className='event-field__label'>Address</p>
                <div className='event-field__control'>
                  <Input
                    name='location.address'
                    value={formik.values.location?.address}
                    handleChange={formik.handleChange}
                    placeholder='Address'
                    label=''
                  />
                </div>
              </div>
              <ErrorMessage
                className='error-text'
                component='p'
                name='location.address'
              />
            </div>

            <div className='col-md-12'>
              <MapViewWrapper
                value={formik.values.location?.mapUrl || ''}
                name='location.mapUrl'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label='Location'
                placeholder='Google Map'
                formik={formik}
              />
              <ErrorMessage
                className='error-text'
                component='p'
                name='location.mapUrl'
              />
            </div>
          </>
        ) : (
          <>
            <div className='col-12 mt-2'>
              <div className='event-field'>
                <p className='event-field__label'>Location Type</p>
                <div className='event-field__control event-field__control--select'>
                  <SelectComponent
                    name='type'
                    options={EVENT_LOCATION_MODE_OPTIONS}
                    selectedValue={formik.values.type}
                    placeholder='Select online or offline'
                    handleChange={(obj) => {
                      const nextType = obj?.value
                      formik.setFieldValue('type', nextType)
                      if (nextType === 'online') {
                        formik.setFieldValue('location.address', '')
                        formik.setFieldValue('location.mapUrl', '')
                      } else {
                        formik.setFieldValue('webLink', '')
                      }
                    }}
                  />
                </div>
                <ErrorMessage className='error-text' component='p' name='type' />
              </div>
            </div>
            <div className='col-12 mt-2 mb-2'>
              <div className='event-field'>
                <p className='event-field__label'>Webinar Link</p>
                <div className='event-field__control'>
                  <Input
                    name='webLink'
                    value={formik.values.webLink}
                    handleChange={formik.handleChange}
                    placeholder='Webinar Link'
                    label=''
                  />
                </div>
              </div>
              <ErrorMessage
                className='error-text'
                component='p'
                name='webLink'
              />
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default LocationTimeStep
